import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const RelatedLinksPage: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'label', headerName: t('relatedLinks.label'), flex: 1, minWidth: 220 },
    {
      field: 'url',
      headerName: t('relatedLinks.url'),
      flex: 2,
      minWidth: 260,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">{params.value}</a>
        ) : null,
    },
  ];

  const fields = [
    { name: 'label', label: t('relatedLinks.label'), type: 'text' as const, required: true, width: 'half' as const },
    { name: 'url', label: t('relatedLinks.url'), type: 'text' as const, required: true, width: 'half' as const },
  ];

  return (
    <GenericTablePage
      tableName="related_links"
      title={t('relatedLinks.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default RelatedLinksPage;
